var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import Auth from '@aws-amplify/auth';
import { SignIn, FormSection, SectionBody, SectionFooter, InputRow, ButtonRow, Link } from 'aws-amplify-react';
import { JS, ConsoleLogger as Logger } from '@aws-amplify/core';
import { parseUrl } from 'query-string';
import { loginWithSessionTokenAsync, GetAuthDetails } from '../../helpers/api';
import validator from "validator";
var isEmail = validator.isEmail;
;
var logger = new Logger('SignIn');
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1(props) {
        var _this = _super.call(this, props) || this;
        _this.error = function (message) {
            _this.setState({
                errorMessage: message
            });
        };
        _this.signIn = _this.signIn.bind(_this);
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.decideAuthenticationMethod = _this.decideAuthenticationMethod.bind(_this);
        _this._validAuthStates = ['signIn', 'signedOut'];
        _this.state = {
            isAuthRevealed: false,
            errorMessage: ""
        };
        return _this;
    }
    default_1.prototype.componentDidMount = function () {
        window.addEventListener('keydown', this.onKeyDown);
        this.decideAuthenticationMethod();
    };
    default_1.prototype.componentWillUnmount = function () {
        window.removeEventListener('keydown', this.onKeyDown);
    };
    default_1.prototype.onKeyDown = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.props.authState === 'signIn')) return [3 /*break*/, 4];
                        if (!(e.keyCode === 13)) return [3 /*break*/, 4];
                        if (!this.state.isAuthRevealed) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.signIn()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.decideAuthenticationMethod()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    default_1.prototype.signIn = function () {
        return __awaiter(this, void 0, void 0, function () {
            var username, password, setLoading, user_1, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.error('');
                        username = this.props.username;
                        password = this.inputs.password;
                        if (!Auth || typeof Auth.signIn !== 'function') {
                            throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
                        }
                        setLoading = this.props.setLoading;
                        setLoading(true);
                        if (!username) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Auth.signIn(username.toLowerCase(), password)];
                    case 2:
                        user_1 = _a.sent();
                        logger.debug(user_1);
                        if (user_1.challengeName === 'SMS_MFA' || user_1.challengeName === 'SOFTWARE_TOKEN_MFA') {
                            setLoading(false);
                            logger.debug('confirm user with ' + user_1.challengeName);
                            this.changeState('confirmSignIn', user_1);
                        }
                        else if (user_1.challengeName === 'NEW_PASSWORD_REQUIRED') {
                            setLoading(false);
                            logger.debug('require new password', user_1.challengeParam);
                            this.changeState('requireNewPassword', user_1);
                        }
                        else if (user_1.challengeName === 'MFA_SETUP') {
                            setLoading(false);
                            logger.debug('TOTP setup', user_1.challengeParam);
                            this.changeState('TOTPSetup', user_1);
                        }
                        else {
                            Auth.verifiedContact(user_1)
                                .then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                                var session, userData;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!!JS.isEmpty(data.verified)) return [3 /*break*/, 3];
                                            session = user_1.getSignInUserSession();
                                            if (!session) return [3 /*break*/, 2];
                                            return [4 /*yield*/, loginWithSessionTokenAsync(session.getIdToken().getJwtToken())];
                                        case 1:
                                            _a.sent();
                                            _a.label = 2;
                                        case 2: return [3 /*break*/, 4];
                                        case 3:
                                            setLoading(false);
                                            userData = Object.assign(user_1, data);
                                            this.changeState('verifyContact', userData);
                                            _a.label = 4;
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        setLoading(false);
                        if (err_1.code === 'UserNotConfirmedException') {
                            logger.debug('the user is not confirmed');
                            this.changeState('confirmSignUp');
                        }
                        else {
                            this.error('Sign in failed. Please check your login details.');
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    default_1.prototype.decideAuthenticationMethod = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, setLoading, setBackgroundImage, username, url, _b, SSOAuthorizeUrl, BackgroundImagePath, err_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.error('');
                        _a = this.props, setLoading = _a.setLoading, setBackgroundImage = _a.setBackgroundImage;
                        username = this.props.username;
                        if (!username) return [3 /*break*/, 4];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        setLoading(true);
                        url = parseUrl(window.location.href).url;
                        return [4 /*yield*/, GetAuthDetails(username, url)];
                    case 2:
                        _b = _c.sent(), SSOAuthorizeUrl = _b.SSOAuthorizeUrl, BackgroundImagePath = _b.BackgroundImagePath;
                        if (BackgroundImagePath) {
                            setBackgroundImage(BackgroundImagePath);
                        }
                        if (SSOAuthorizeUrl) {
                            return [2 /*return*/, window.location.replace(SSOAuthorizeUrl)];
                        }
                        else {
                            // Reveal regular authentication 
                            setLoading(false);
                            this.setState({ isAuthRevealed: true });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _c.sent();
                        setLoading(false);
                        this.setState({ isAuthRevealed: true });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    default_1.prototype.showComponent = function (theme) {
        var _this = this;
        var _a = this.props, username = _a.username, onChangeUsername = _a.onChangeUsername;
        var buttonDisabled = !(username && isEmail(username));
        return (React.createElement(FormSection, { theme: theme },
            React.createElement(SectionBody, { theme: theme },
                React.createElement(InputRow, { autoFocus: true, placeholder: 'Email', theme: theme, key: "username", name: "username", value: username, onChange: onChangeUsername }),
                React.createElement("div", { style: {
                        overflow: 'hidden',
                        maxHeight: this.state.isAuthRevealed ? '200px' : 0,
                        transition: 'max-height 0.5s ease-in-out'
                    } },
                    React.createElement(InputRow, { placeholder: 'Password', theme: theme, key: "password", type: "password", name: "password", onChange: this.handleInputChange })),
                React.createElement(ButtonRow, { theme: theme, onClick: this.state.isAuthRevealed ? this.signIn : this.decideAuthenticationMethod, disabled: buttonDisabled, id: buttonDisabled ? 'disabledButton' : undefined }, this.state.isAuthRevealed ? 'Sign In' : 'Next')),
            React.createElement(SectionFooter, { theme: theme },
                React.createElement(Link, { theme: theme, style: { display: this.state.isAuthRevealed ? 'block' : 'none' }, onClick: function () { return _this.changeState('forgotPassword', _this.inputs.username); } }, "Reset Password")),
            React.createElement(React.Fragment, null, this.state.errorMessage && (React.createElement("div", { style: { padding: "10px", textAlign: "center", backgroundColor: "orangered", color: "white" }, className: "error-message" }, this.state.errorMessage)))));
    };
    return default_1;
}(SignIn));
export default default_1;
//# sourceMappingURL=SignIn.js.map